import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Edit } from '@mui/icons-material';
import { Box, Avatar, Typography, IconButton, useTheme } from '@mui/material';

import { AgentStatus } from '@bandido/shared/constants';

import { disconnectedUser } from '@frontend/assets';
import { getAgentStatusColor } from '@frontend/features/users/helpers';
import { useAuth } from '@frontend/features/auth/hooks/useAuth';
import UserStatusMenu from '@frontend/features/users/components/UserStatusMenu';

import { Badge } from '../Badge';
import { QueryKeys } from '../../types';


export const Profile: FC = () => {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const { myProfile, isAuthenticated, toggleProfileEditor } = useAuth();

  const { t } = useTranslation();

  const userImage = myProfile?.profilePicture || disconnectedUser;
  const handleAnchorElement = (event: React.MouseEvent<HTMLSpanElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  if (!myProfile || !isAuthenticated) {
    return null;
  }

  const agentStatus = myProfile.status;

  return (
    <Box sx={{ width: 320 }}>
      <Box
        display={'flex'}
        flexDirection={'column'}
        justifyContent={'center'}
        alignItems={'flex-start'}
        pb={2}
        pr={2}
        pl={2}
      >
        <Box display="flex" mb={2} alignItems="baseline" gap={1}>
          <Box onClick={handleAnchorElement} display="flex" mb={2} alignItems="baseline" gap={1}>
            <Badge isUserMenu color={agentStatus && getAgentStatusColor(agentStatus as AgentStatus, theme)}>
              <Avatar
                variant="circular"
                alt={`${myProfile.firstName} ${myProfile.lastName}`}
                src={userImage}
                sx={{ width: 60, height: 60 }}
              />
            </Badge>
            <Typography variant="subtitle2">{t(`agentStatus.${agentStatus ?? AgentStatus.NOT_AVAILABLE}`)}</Typography>
          </Box>
          <UserStatusMenu
            userId={myProfile.id}
            queryKeys={[QueryKeys.getAllUsers, QueryKeys.getMyUserData]}
            onClose={handleClose}
            anchorEl={anchorEl}
          />
        </Box>
        <Box display="flex" gap={1}>
          <Typography variant="h6">
            {myProfile.firstName} {myProfile.lastName}
          </Typography>
          <IconButton aria-label="edit profile" onClick={toggleProfileEditor}>
            <Edit />
          </IconButton>
        </Box>
        <Box display={'flex'} alignItems={'center'}>
          <Typography color="text.disabled" variant="subtitle1">
            {myProfile.email}
          </Typography>
        </Box>
      </Box>

      
    </Box>
  );
};
